export default function ThreadTable() {
  const fieldStyle = 'h-6 w-full flex items-center justify-center'

  return (
    <>
      <table className="relative w-full px-4 border-2 table-fixed print:w-11/12 border-primary-dark print:border">
        <thead className="w-full text-white bg-primary-dark">
          <tr className="w-full border-b divide-x print:border-b-0 print:divide-x-0 divide-primary divide-solid border-primary">
            <th className="w-1/12 text-sm print:text-xs"></th>

            <th className="w-6/12 text-sm print:w-7/12 print:text-xs">
              Matèria
            </th>

            <th className="w-1/12 text-sm print:text-xs">GRS</th>

            <th className="w-2/12 text-sm print:text-xs">Nº Cons</th>

            <th className="w-2/12 text-sm print:text-xs">Percentatge</th>
          </tr>
        </thead>

        <tbody className="w-full divide-y print:divide-red-200 print:divide-dashed divide-primary divide-solid">
          {[...Array(4)].map((_, index) => (
            <tr
              className="w-full divide-x print:divide-red-200 print:divide-dashed divide-primary divide-solid"
              key={index}
            >
              {/* Campo 'Fil x': */}
              <td className="w-1/12 text-center print:text-xs">
                <div className="flex items-center">Fil {index}</div>
              </td>

              {/* Campo 'Matèria': */}
              <td className="w-6/12 print:w-7/12 py-1 print:py-0.5">
                <div className={fieldStyle} />
              </td>

              {/* Campo 'GRS': */}
              <td className="w-2/12">
                <div className={fieldStyle} />
              </td>

              {/* Campo 'Nº Cons': */}
              <td className="w-2/12">
                <div className={fieldStyle} />
              </td>

              {/* Campo 'Percentatge': */}
              <td className="w-2/12">
                <div className={fieldStyle} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex-row items-center justify-center hidden w-1/12 print:flex">
        <span className="w-6 h-6 border border-black"></span>
      </div>
    </>
  )
}

ThreadTable.propTypes = {}
